import { useEffect, useState } from "react";
import { useStore } from "../stores/store";
import agent from "../api/agent";
import { getShopifyAppHandle } from "../utils/shopifyAdmin";

interface Props {
    children: React.ReactNode;
}

export default function RequireSubscription({ children }: Props) {
    const { userStore } = useStore();
    const [checkingSub, setCheckingSub] = useState(true);
    const [hasSubscription, setHasSubscription] = useState(true); // assume yes

    useEffect(() => {

        const checkSubscription = async () => {
            if (!userStore.isLoggedIn) {
                setCheckingSub(false);
                return;
            }

            try {
                const result = await agent.Account.getSubscriptionStatus();
                setHasSubscription(result.hasActiveSubscription);
            } catch (error) {
                console.error("Failed to verify subscription status", error);
                setHasSubscription(false);
            } finally {
                setCheckingSub(false);
            }
        };

        checkSubscription();
    }, [userStore.isLoggedIn]);

    if (checkingSub) return null;

    if (!hasSubscription) {
        if (!window.location.pathname.startsWith("/exit-iframe")) {
            const params = new URLSearchParams(window.location.search);
            const shopParam = params.get("shop");
            const shop = (shopParam || userStore.user?.shopDomain)?.replace(".myshopify.com", "") ?? "";
            const appHandle = getShopifyAppHandle();

            // Shopify Admin cannot be rendered inside our iframe. Route through
            // ExitIframe so the billing page opens at the top window instead.
            const subscriptionUrl = `https://admin.shopify.com/store/${shop}/apps/${appHandle}/pricing_plans`;
            window.location.href = `/exit-iframe?redirectUri=${encodeURIComponent(subscriptionUrl)}`;
            return null;
        }
        return null;
    }


    return <>{children}</>;
}
